import {Service} from './';

export class ConfigService extends Service {

  static entity: string = 'app/config';

  static get(key: string): Promise<any> {
    return this.axios.get(`${this.entity}/${key}`).then(res => res.data);
  }

  static set(key: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${key}`, data).then(res => res.data);
  }

}
